"use strict";

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeature = void 0;

var _uuid = require("uuid");

var _fullscriptJsValidator = require("../fullscriptJsValidator");

var _iframe = require("../iframe");

var _utils = require("../utils");

var _featureUtil = require("./featureUtil");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getFeature = (featureType, featureOptions, fullscriptOptions, dispatcher) => {
  var mountPoint;
  var frameId = (0, _uuid.v4)(); // TODO: If we can only mount a feature once, throw an error if attempting to mount a second time

  var mount = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (elementId) {
      var url = yield (0, _featureUtil.getFeatureURL)(featureType, featureOptions, fullscriptOptions, frameId);
      mountPoint = document.getElementById(elementId);
      (0, _fullscriptJsValidator.validateMountPoint)(mountPoint);
      var iframe = (0, _iframe.createIframe)(url);
      mountPoint.appendChild(iframe);
    });

    return function mount(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var unmount = () => {
    (0, _utils.removeChildren)(mountPoint);
    dispatcher.unregisterAllFeatureEventListeners(frameId);
  };

  var on = (eventType, callback) => {
    (0, _fullscriptJsValidator.validateFeatureEventType)(eventType);
    dispatcher.registerEventListener("".concat(frameId, ".").concat(eventType), callback);
  };

  var off = (eventType, callback) => {
    (0, _fullscriptJsValidator.validateFeatureEventType)(eventType);
    dispatcher.unregisterEventListener("".concat(frameId, ".").concat(eventType), callback);
  };

  return {
    mount,
    unmount,
    on,
    off
  };
};

exports.getFeature = getFeature;